export function renderSearchCategories(container, results) {
	if (!container) return;
	container.innerHTML = '';

	results.category.forEach((category) => {
		const categoryItem = document.createElement('div');
		categoryItem.className = 'search-result-aside__item';
		categoryItem.innerHTML = `
			<a href="${category.product[0].href}" class="search-result-aside__link">${category.product[0].name}</a>
			<a href="${category.category[0].href}" class="search-result-aside__category-link">В категории “${category.category[0].name}"</a>
		`;
		container.appendChild(categoryItem);
	});
}
